import React, { useEffect } from 'react';

type Props = {
    enabled: boolean;
};

const LEADFEEDER_TRACKER_ID = 'lYNOR8xJrgY4WQJZ';

declare global {
    interface Window {
        ldfdr?: (...args: unknown[]) => void;
    }
}

export const Leadfeeder: React.FC<Props> = ({ enabled }) => {
    useEffect(() => {
        if (!enabled) return undefined;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.textContent = `(function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));}; (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1; fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })('${LEADFEEDER_TRACKER_ID}');`;
        document.head.appendChild(script);
        return () => script.remove();
    }, [enabled]);

    return null;
};
